import { FileMultipleIcon } from './FileMultipleIcon';

/**
 * author: Simran
 * id 7696AF65-B943-4BA3-94DB-5E85077F7BA9
 * name file-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-multiple.svg
 * tags
 * - Files / Folders 
 */
export const FilesIcon = FileMultipleIcon;
export default FilesIcon